import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { registerSW } from 'virtual:pwa-register';
import Toaster from '@meforma/vue-toaster';
import { browserTracingIntegration, init } from '@sentry/vue';
import { useEnviroment } from '@/composables';

import router from './router';
import App from './App.vue';

if ('serviceWorker' in navigator) {
  registerSW({
    immediate: true,
  });
}

// yup must be registered before vee-validate
const pluginsEntries = Object.entries(import.meta.glob('./plugins/*.ts', { eager: true })).sort(
  (a, b) => {
    const [pathA] = a;
    const [pathB] = b;

    if (pathA.includes('yup.ts')) return -1;
    if (pathB.includes('yup.ts')) return 1;

    return pathA.localeCompare(pathB);
  },
);

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(Toaster);

pluginsEntries.forEach(([, plugin]) => app.use(plugin.default));

if (import.meta.env.PROD && !useEnviroment().isStaging) {
  // Init Sentry
  init({
    app,
    dsn: 'https://4ce05232fc45415bbb60984f9c476e87@o4504096227328000.ingest.sentry.io/4504135225245696',
    integrations: [browserTracingIntegration({ router })],
    tracePropagationTargets: ['infineat-production.herokuapp.com'],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.5,
    sampleRate: 0.6,
  });
}

app.mount('#app');
